import React, { useEffect } from 'react';

declare global {
  interface Window {
    ttq?: any;
    TiktokAnalyticsObject?: any;
  }
}

type Props = {
  pixelId?: string; // facultatif, par défaut ton ID
};

const PixelTikTok: React.FC<Props> = ({ pixelId = 'D3P1VPJC77U1STIOKMSG' }) => {
  useEffect(() => {
    // on n’injecte qu’une seule fois
    if (typeof window !== 'undefined' && !window.ttq) {
      (function (w: any, d: Document, t: string) {
        w.TiktokAnalyticsObject = t;
        const ttq = (w[t] = w[t] || []);
        ttq.methods = [
          'page',
          'track',
          'identify',
          'instances',
          'debug',
          'on',
          'off',
          'once',
          'ready',
          'alias',
          'group',
          'enableCookie',
          'disableCookie',
          'holdConsent',
          'revokeConsent',
          'grantConsent',
        ];
        ttq.setAndDefer = function (obj: any, method: string) {
          obj[method] = function () {
            obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        };
        for (let i = 0; i < ttq.methods.length; i++) {
          ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        ttq.instance = function (name: string) {
          const inst = ttq._i[name] || [];
          for (let i = 0; i < ttq.methods.length; i++) {
            ttq.setAndDefer(inst, ttq.methods[i]);
          }
          return inst;
        };
        ttq.load = function (id: string, opts?: Record<string, any>) {
          const src = 'https://analytics.tiktok.com/i18n/pixel/events.js';
          ttq._i = ttq._i || {};
          ttq._i[id] = [];
          ttq._i[id]._u = src;
          ttq._t = ttq._t || {};
          ttq._t[id] = +new Date();
          ttq._o = ttq._o || {};
          ttq._o[id] = opts || {};

          const s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = `${src}?sdkid=${id}&lib=${t}`;
          const firstScript = d.getElementsByTagName('script')[0];
          firstScript.parentNode?.insertBefore(s, firstScript);
        };

        // charge le pixel
        ttq.load(pixelId);
        // NE PAS appeler ttq.page() ici pour éviter la double pageview en SPA.
      })(window, document, 'ttq');
    }
  }, [pixelId]);

  // TikTok ne fournit pas de <noscript> standard comme Meta;
  // on peut s’en passer.
  return null;
};

export default PixelTikTok;
